<template>
  <div v-if="loading" class="preeloader">
    <div class="loader">
      <span class="bounce1"></span>
      <span class="bounce2"></span>
      <span class="bounce3"> </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Preloader',
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss">
/* Preloader
============================================================================================ */
.preeloader {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 999;

  .loader {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    @include transform(translate(-50%, -50%));

    span {
      width: 16px;
      height: 18px;
      background-color: #c2c2d6;

      border-radius: 100%;
      display: inline-block;
      -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .bounce1 {
      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }

    .bounce2 {
      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
      0%,
      80%,
      100% {
        -webkit-transform: scale(0);
      }
      40% {
        -webkit-transform: scale(1);
      }
    }

    @keyframes sk-bouncedelay {
      0%,
      80%,
      100% {
        -webkit-transform: scale(0);
        transform: scale(0);
      }
      40% {
        -webkit-transform: scale(1);
        transform: scale(1);
      }
    }
  }
}
</style>
